import makeStyles from '@material-ui/styles/makeStyles';

export const useStyles = makeStyles({
  root: {
    display: props => props.isHide ? 'none' : 'flex',
    alignItems: 'center'
  },
  line: {
    width: '47.5%',
    height: 1,
    backgroundColor: '#E3E3E3'
  }
});
